import React, { useEffect, useRef, useState } from "react";
import Layout from "../../Components/Layout/Layout";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  useDeleteAdminMutation,
  useEditAdminMutation,
  useGetAdminsQuery,
} from "../../store/Api/admins";
import {
  convertDDMMYYYY,
  hidetoast,
  useDecodeToken,
} from "../../Utils/function";
import { useGetRrbQuery } from "../../store/Api/common";
import {
  useDeleteAuditQuestionMutation,
  useEditAuditQuestionMutation,
  useGetAuditsQuestionsQuery,
  useReoderAuditQuestionMutation,
} from "../../store/Api/auditsQuestions";
import { render } from "@testing-library/react";
import { useDispatch, useSelector } from "react-redux";
import ECAAuditUi from "./ECAAuditUi";
import { useSaveEcaAuditMutation } from "../../store/Api/ecaAudit";
import { useGetViewAuditsQuery } from "../../store/Api/audits";
import { rowsPerPage } from "../../Utils/constant";

function ECAAudit() {
  const navigate = useNavigate();
  const [deleteId, setDeleteId] = useState("");
  const decodedToken = useDecodeToken();
  const [tableQaury, setTableQaury] = useState({
    search: "",
    rowsPerPage: rowsPerPage,
    currentPage: 1,
    rrbId: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",
  });
  const [deleteAuditQuestion] = useDeleteAuditQuestionMutation();
  const [saveEcaAudit] = useSaveEcaAuditMutation();
  const dispatch = useDispatch();
  const toast = useSelector((state) => state.toast);
  const location = useLocation();
  const { state } = location;
  const id = state?.data?.id;
  // const { id } = useParams();
  const [dragId, setDragId] = useState();
  const [boxes, setBoxes] = useState([]);
  const [qD, setqD] = useState();
  const [error, setError] = useState([]);

  const { data, isFetching, isLoading, refetch } = useGetAuditsQuestionsQuery({
    search: tableQaury.search,
    limit: tableQaury.rowsPerPage,
    page: tableQaury.currentPage,
  });

  console.log('sddds',data);

  // Fetch and process state data

  // Auto-hide toast after 3 seconds
  useEffect(() => {
    if (toast.message) {
      hidetoast();
    }
  }, [toast.message, dispatch]);
  useEffect(() => {
    const questionData = data?.data?.map((item) => ({
      ...item,
      answer: JSON.parse(item?.answer),
      options: JSON.parse(item?.options),
      sub_question: subFn(item?.sub_question),
      user_answer: [
        item?.default_question_type == "audit_date"
          ? convertDDMMYYYY(new Date())
          : "",
      ],
    }));
 setqD(data?.data)
    setBoxes(questionData);
  }, [data]);
  //   useEffect(() => {
  //     if (state?.ecaData && state?.update && data) {
  //         const arr =[]
  //       const auditData = state?.ecaData?.eca_audit?.audit_data

  //       auditData && Object.entries(auditData)?.map(([key, value]) => {
  //         // Fetch main question userAnswer
  //         const userAnswer = (value['user_answer'] || []).map((e) => e.toString());

  //         // Fetch sub-questions
  //         const subUserAnswer = value['sub_question'];

  //         Array.isArray(data) && data.map((data) => {
  //           if (data.id.toString() === value['id'].toString()) {
  //             // Add userAnswer to MasterQuestionData Model
  //             data.user_answer = userAnswer;

  //            console.log(data,"ss");

  //             // Add userAnswer to MasterSubQuestionData Model
  //             if (data.sub_question && subUserAnswer) {
  //                 Array.isArray(data.sub_question) && data.sub_question?.forEach((key,subData) => {
  //                 Object.entries(subUserAnswer).forEach(([subKey, subValue]) => {
  //                   const subUserAnswer = (subValue['user_answer'] || []).map((e) =>
  //                     e.toString()
  //                   );

  //                   if (subData.id.toString() === subValue['id'].toString()) {
  //                     subData.user_answer = subUserAnswer;

  //                   }
  //                 });
  //               });
  //             }
  //             arr.push(data)
  //           }
  //         });
  //       });
  //       console.log(auditData,"auditData");

  //       const temdata = Object.values(auditData);
  //     console.log(temdata,"temdata");

  //     setBoxes(temdata)
  //         }
  //   }, [data]);

  useEffect(() => {
    if (state?.ecaData && state?.update && data) {
      const auditData = state?.ecaData?.eca_audit?.audit_data;

      const questionData = data?.data?.map((item) => ({
        ...item,
        answer: JSON.parse(item?.answer),
        options: JSON.parse(item?.options),
        sub_question: subFn(item?.sub_question),
        user_answer: [],
      }));

      let arr = [];
      Object.entries(auditData).forEach(([key, value]) => {
        // Fetch main question userAnswer
        const userAnswer = value.user_answer
          ? value.user_answer.map((e) => e.toString())
          : null;
        arr.push(value);
        // Fetch sub-questions
        // const subUserAnswer = value.sub_question;

        // questionData?.forEach((data, index) => {
        //   if (data.id.toString() === value.id.toString()) {
        //     // Create a mutable copy of the data object
        //     const mutableData = { ...data };

        //     // Add userAnswer to MasterQuestionData Model
        //     mutableData.user_answer = userAnswer;

        //     // Replace the original immutable object with the mutable one
        //     // data.data[index] = mutableData;

        //     // Handle sub_question
        //     if (
        //       mutableData.sub_question &&
        //       Array.isArray(mutableData.sub_question)
        //     ) {
        //       mutableData.sub_question = mutableData.sub_question.map(
        //         (subData) => {
        //           const mutableSubData = { ...subData };

        //           if (subUserAnswer && Object.keys(subUserAnswer).length > 0) {
        //             Object.entries(subUserAnswer).forEach(
        //               ([subKey, subValue]) => {
        //                 const subUserAnswerList = subValue.user_answer
        //                   ? subValue.user_answer.map((e) => e.toString())
        //                   : null;

        //                 if (
        //                   mutableSubData.id.toString() ===
        //                   subValue.id.toString()
        //                 ) {
        //                   // Add userAnswer to sub_question
        //                   mutableSubData.user_answer = subUserAnswerList;
        //                 }
        //               }
        //             );
        //           }

        //           return mutableSubData; // Return the updated mutable subData
        //         }
        //       );
        //     }
        //     arr.push(mutableData);
        //   }
        // });
      });
      setBoxes(arr);
    }
  }, [data]);

  const subFn = (val) => {
    let data = [];
    if (val?.length >= 1 && val[0] !== "") {
      data = val?.map((subVal) => {
        return {
          ...subVal,
          answer: JSON.parse(subVal?.answer),
          options: JSON.parse(subVal?.options),
          user_answer: [],
        };
      });
    } else {
      data = [];
    }
    return data;
  };

  const containerRef = useRef(null);

  const onUpdate = async (row) => {
    navigate(`/update-audit-question/${row?.id}`, { state: row });
  };
  const onView = async (row) => {
    navigate(`/view-audit-question/${row?.id}`, { state: { row } });
  };

  const deleteFn = async () => {
    try {
      const response = await deleteAuditQuestion({ id: deleteId });
      if (response?.data?.success) {
        // Call refetch to refresh the user list
        refetch();
      }
    } catch (error) {
      console.log(error, "verify otp error");
    }
  };
  const handlePageChange = (newPage) => {
    // setCurrentPage(newPage);
    setTableQaury({ ...tableQaury, currentPage: newPage });
  };

  function validateQuestions(questions) {
    const errors = [];
    function validateSubQuestion(question, index, ind) {
      const {
        question: text,
        mandatory,
        user_answer,
        input_type,
        sub_question,
      } = question;

      // Check if the question is mandatory and has no valid answer
      if (
        mandatory &&
        (!user_answer ||
          user_answer.length === 0 ||
          (Array.isArray(user_answer)
            ? user_answer.every((ans) => ans.trim() === "")
            : user_answer.trim() === ""))
      ) {
        errors.push({
          ind: index,
          subInd: ind,
          err: "Answer is required for the question",
        });
      }

      // If it's a checkbox with "multiple" or "single" type, validate further if needed
      if (input_type === "checkbox" && question.checkbox_type) {
        if (
          question.checkbox_type === "single" &&
          mandatory &&
          (!user_answer || user_answer.length !== 1)
        ) {
          errors.push({
            ind: index,
            subInd: ind,
            err: "Answer is required for the question",
          });
        }
      }
    }
    // Recursive function to validate questions and sub-questions
    function validateQuestion(question, index) {
      const {
        question: text,
        mandatory,
        user_answer,
        input_type,
        sub_question,
      } = question;

      // Check if the question is mandatory and has no valid answer
      if (
        mandatory &&
        (!user_answer ||
          user_answer.length === 0 ||
          (Array.isArray(user_answer)
            ? user_answer.every((ans) => ans.trim() === "")
            : user_answer.trim() === ""))
      ) {
        errors.push({ ind: index, err: "Answer is required for the question" });
      }

      // If it's a checkbox with "multiple" or "single" type, validate further if needed
      if (input_type === "checkbox" && question.checkbox_type) {
        if (
          question.checkbox_type === "single" &&
          mandatory &&
          (!user_answer || user_answer.length !== 1)
        ) {
          errors.push({
            ind: index,
            err: "Answer is required for the question",
          });
        }
      }

      // Validate sub-questions recursively
      if (
        sub_question &&
        Array.isArray(sub_question) &&
        question?.checkbox_type === "multiple"
      ) {
        sub_question?.forEach((val, ind) =>
          validateSubQuestion(val, index, ind)
        );
      }
    }

    // Validate the main question and all its sub-questions
    questions?.forEach((val, index) => validateQuestion(val, index));

    return errors;
  }
  const saveAnswer = async ({ step, status }) => {
    const newMapMainData = {};
    boxes.forEach((data) => {
      const newMapSubData = {};
      if (
        data?.sub_question?.length &&
        data?.input_type == "checkbox" &&
        data?.checkbox_type == "multiple"
      ) {
        data?.sub_question.forEach((subData) => {
          newMapSubData[`sub_ques_${subData.id}`] = {
            ...subData,
            user_id: decodedToken?.id,
          };
        });
      }

      newMapMainData[`ques_${data.id}`] = {
        ...data,
        user_id: decodedToken?.id,
        sub_question: newMapSubData,
      };
    });

    const formatDate = (dateString) => {
      return dateString.replace(/\//g, "-");
    };

    const auditData = {
      step,
      centre_id: state?.ecaData?.centre_id,
      cen_id: state?.ecaData?.cen_id,
      rrb_id: state?.ecaData?.rrb_id,
      user_id: decodedToken?.id,
      audit_date: formatDate(boxes[0].user_answer[0]),
      status,
      audit_data: newMapMainData,
    };

    // Call saveEcaAudit mutation
    try {
      const response = await saveEcaAudit({
        id: state?.update ? id : 0,
        data: auditData,
      });
      if (response?.data?.success) {
        navigate(`/eca-audits`);
      }
    } catch (error) {
      console.log(error, "verify otp error");
    }
  };
  const handleSubmit = async () => {
    const validationErrors = validateQuestions(boxes);
    if (validationErrors?.length > 0) {
      setError(validationErrors);
      return;
    }

    // Call saveAnswer function for saving the audit data
    saveAnswer({ step: 1, status: "completed" }); // Pass necessary values here
  };
console.log(qD,'qddddddddddd')
  return (
    <Layout>
      <ECAAuditUi
        data={boxes || []}
        setBoxes={setBoxes}
        // data={boxes}
        loading={isLoading}
        deleteAdminFn={deleteFn}
        questionD={qD}
        containerRef={containerRef}
        toast={toast}
        boxes={boxes}
        handleSubmit={handleSubmit}
        error={error}
        setError={setError}
        validateQuestions={validateQuestions}
      />
    </Layout>
  );
}

export default ECAAudit;
